/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import * as React from 'react';
import { Helmet } from 'react-helmet';
import smoothScroll from 'smooth-scroll';
import PropTypes from 'prop-types';
import '@reach/dialog/styles.css';
import '@reach/menu-button/styles.css';
import '@reach/tabs/styles.css';

import { ThemeContextProvider, StoreContextProvider } from './src/context';
import './src/css/tailwind.css';

export const wrapRootElement = ({ element }) => (
  <ThemeContextProvider>
    <StoreContextProvider>
      <Helmet>
        <link rel="preconnect" href="//hello.myfonts.net" crossOrigin />
        <link rel="preconnect" href="//cdn.shopify.com" crossOrigin />
        <script>
          {`
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '145925746089592');
  fbq('track', 'PageView');`}
        </script>
        <noscript>
          {`
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=145925746089592&ev=PageView&noscript=1"
          />`}
        </noscript>
      </Helmet>
      {element}
    </StoreContextProvider>
  </ThemeContextProvider>
);

wrapRootElement.propTypes = {
  element: PropTypes.node.isRequired,
};

// Lazy load intersection observer polyfill
export const onClientEntry = async () => {
  if (typeof IntersectionObserver === 'undefined') {
    await import('intersection-observer');
    console.log('Loaded IntersectionObserver polyfill');
  }
};

// https://medium.com/@chrisfitkin/how-to-smooth-scroll-links-in-gatsby-3dc445299558
if (typeof window !== 'undefined') {
  smoothScroll('a[href*="#"]');
}
